export default "__VITE_ASSET__48b201bd__"